import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanSupplyForSubcontractDetail extends BaseModelAPI {
	static entity = 'suratjalansupplyforsubcontractdetail';
	static entityName = 'suratjalansupplyforsubcontractdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.suratJalanSupplyForSubcontractId = '';
			this.suratJalanSupplyForSubcontract = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.orderQty = 0;
			this.deliveryQty = 0;
			this.workOrderSupplySubcontractDetailId = '';
			this.workOrderSupplySubcontractDetail = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}